import React from 'react'
import { Checkbox } from '~/lib/ui/checkbox'
import { useTranslation } from '~/hooks/useTranslation'

const RecommendedFileAttachments = ({
  defaultFeedbackAttachmentKeys,
  attachmentKeys,
  onCheckedChange,
}) => {
  const { t } = useTranslation('RecommendedFileAttachments')

  return (
    <div className="mb-4 flex flex-col gap-2">
      <div className="text-lg font-medium">Recommended File Attachments</div>
      {defaultFeedbackAttachmentKeys.map((key, _index) => (
        <div key={key}>
          <label className="!flex items-center !font-normal">
            <Checkbox
              className="mr-2"
              checked={attachmentKeys.includes(key)}
              onCheckedChange={onCheckedChange(key)}
            />
            {t(`attachment_labels.${key}`)}
          </label>
        </div>
      ))}
    </div>
  )
}

export default RecommendedFileAttachments
